export default __webpack_public_path__ + "static/media/sa.24591ce6.jpg";